define('FilterCommerceCategories.Model',
  [
    'SCModel',
    'Utils'
  ],
  function (
    SCModelComponent,
    Utils
  ) {
    'use strict';

    var SCModel = SCModelComponent.SCModel;

    function FilterCommerceCategoriesModel() {
      
      SCModel.call(this);

      this.urlRoot = function urlRoot() {
        return Utils.getAbsoluteUrl(
          getExtensionAssetsPath('Modules/FilterCommerceCategories/SuiteScript2/FilterCommerceCategories.Service.ss'),
          true
        );
      };

    }
    FilterCommerceCategoriesModel.prototype = Object.create(SCModel.prototype);

    FilterCommerceCategoriesModel.prototype.constructor = FilterCommerceCategoriesModel;

    return FilterCommerceCategoriesModel;
  });
